export default function (value) {
  if (value == "CERRADA" || value == "CANCELADO" || value == "apuesta")
    return "#eb262c";
  else if (value == "CORRIENDO") return "orange";
  else return "#00afef";
}